<template>
  <div v-if="isDesktop" class="gallery">
    <img
      v-for="(image, key) in images"
      class="gallery__item"
      alt="img"
      :src="image.lg || image.original"
      :key="key"
      v-reveal
    />
  </div>

  <div class="gallery-mobile" v-reveal>
    <transition name="fade" mode="out-in">
      <div class="gallery-mobile__img" :key="`img-${galleryKey}`">
        <img :src="images[galleryKey].lg" />
      </div>
    </transition>

    <div class="gallery-mobile__nav" v-reveal>
      <div
        class="gallery-mobile__nav-item"
        :class="{ '-active': galleryKey === key }"
        v-for="(item, key) in images"
        @click="galleryKey = key"
      >
        {{ `${key > 9 ? '' : '0'}${key + 1}` }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      galleryKey: 0,
    }
  },
  computed: {
    isDesktop() {
      return true
    },
  },
}
</script>
